export default {
  backgroundColor: "#f6dadb",
  screenBackgroundColor: "#fefefe",
  screenLightShadow: "-31px -31px 62px #FAE0E0",
  screenDarkShadow: "31px 31px 62px #EAB6BE",
  isRounded: true,
}